export type AppConfig = {
    [key in 'local' | 'development' | 'rc' | 'staging' | 'production']: {
        appUrl: string
        auth: {
            clientId: string
            url: string,
        },
        ea: {
            baseUrl: string,
        },
        logging: {
            server: string
            context: {
                ls_source: string
                env: string
                product: string,
            },
        },
    }
};

const LOGGING_SOURCE = 'getgo.g2c';
const PRODUCT_NAME = 'g2c';

export const AppConfig: AppConfig = {
    local: {
        appUrl: 'https://localhost:3443/',
        auth: {
            clientId: 'e414652e-fea8-4215-bf22-d31eb94452b1',
            url: 'https://authenticationed1.lmiinc.test.expertcity.com',
        },
        ea: {
            baseUrl: 'https://admined1.lmiinc.test.expertcity.com',
        },
        logging: {
            server: 'https://logginged1.getgo.test.expertcity.com',
            context: {
                ls_source: LOGGING_SOURCE,
                env: 'dev',
                product: PRODUCT_NAME,
            },
        },
    },

    development: {
        appUrl: 'https://paired1.dev.gotoroom.com/',
        auth: {
            clientId: 'e414652e-fea8-4215-bf22-d31eb94452b1',
            url: 'https://authenticationed1.lmiinc.test.expertcity.com',
        },
        ea: {
            baseUrl: 'https://admined1.lmiinc.test.expertcity.com',
        },
        logging: {
            server: 'https://logginged1.getgo.test.expertcity.com',
            context: {
                ls_source: LOGGING_SOURCE,
                env: 'dev',
                product: PRODUCT_NAME,
            },
        },
    },
    rc: {
        appUrl: 'https://pairrc1.dev.gotoroom.com/',
        auth: {
            clientId: '6fd13b13-db19-407f-a351-cc209bc63cd5',
            url: 'https://authenticationrc1.lmiinc.test.expertcity.com',
        },
        ea: {
            baseUrl: 'https://adminrc1.lmiinc.test.expertcity.com',
        },
        logging: {
            server: 'https://loggingrc1.getgo.test.expertcity.com',
            context: {
                ls_source: LOGGING_SOURCE,
                env: 'rc',
                product: PRODUCT_NAME,
            },
        },
    },
    staging: {
        appUrl: 'https://pairstage.gotoroom.com',
        auth: {
            clientId: '2793ca0e-7472-4911-9c31-ca5ef1bed658',
            url: 'https://authenticationstage.logmeininc.com',
        },
        ea: {
            baseUrl: 'https://adminstage.logmeininc.com',
        },
        logging: {
            server: 'https://loggingstage.getgo.com',
            context: {
                ls_source: LOGGING_SOURCE,
                env: 'stage',
                product: PRODUCT_NAME,
            },
        },
    },

    production: {
        appUrl: 'https://pair.gotoroom.com/',
        auth: {
            clientId: '4ebdca0c-7c00-4393-aefc-b46111a9d6f1',
            url: 'https://authentication.logmeininc.com',
        },
        ea: {
            baseUrl: 'https://admin.logmeininc.com',
        },
        logging: {
            server: 'https://logging.getgo.com',
            context: {
                ls_source: LOGGING_SOURCE,
                env: 'prod',
                product: PRODUCT_NAME,
            },
        },
    },
};

export const getEnvironment = (): string | undefined =>
    AppConfig && Object.keys(AppConfig).find((env) => new URL(AppConfig[env].appUrl).hostname === window.location.hostname);

export const getConfig = () => ({
    ...AppConfig[getEnvironment() || 'local'],
    ENV: getEnvironment(),
    IS_TEST_ENV: navigator.userAgent === 'chromium-e2e',
});
